/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

(function (window) {
	var ProductItemExtraIndex = 0;
	var allItemsExtra = [];
	var headerRellax = null;
	var videoAllowed = true;
	var initialized = false;

	$(document).ready(init);

	function buildSourcesArray() {
		/*listItemExtrasVideos
    listItemExtras*/
		/*allItemsExtra = [];

    if (listItemExtrasVideos.length) {
      var videosCopy = listItemExtrasVideos.slice(0);
      window.shuffleArray(videosCopy);
      allItemsExtra.push(videosCopy.shift());
      var allItemsExtra2 = listItemExtras.concat(videosCopy);
      window.shuffleArray(allItemsExtra2);
      allItemsExtra = allItemsExtra.concat(allItemsExtra2);
    } else {
      allItemsExtra = allItemsExtra.concat(listItemExtras);
      window.shuffleArray(allItemsExtra);
    }*/
	}

	function init() {
		if (typeof Promise === "function") {
			var mp4 =
				"data:video/mp4;base64,AAAAFGZ0eXBNU05WAAACAE1TTlYAAAOUbW9vdgAAAGxtdmhkAAAAAM9ghv7PYIb+AAACWAAACu8AAQAAAQAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAAAnh0cmFrAAAAXHRraGQAAAAHz2CG/s9ghv4AAAABAAAAAAAACu8AAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAABAAAAAAFAAAAA4AAAAAAHgbWRpYQAAACBtZGhkAAAAAM9ghv7PYIb+AAALuAAANq8AAAAAAAAAIWhkbHIAAAAAbWhscnZpZGVBVlMgAAAAAAABAB4AAAABl21pbmYAAAAUdm1oZAAAAAAAAAAAAAAAAAAAACRkaW5mAAAAHGRyZWYAAAAAAAAAAQAAAAx1cmwgAAAAAQAAAVdzdGJsAAAAp3N0c2QAAAAAAAAAAQAAAJdhdmMxAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAFAAOABIAAAASAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGP//AAAAEmNvbHJuY2xjAAEAAQABAAAAL2F2Y0MBTUAz/+EAGGdNQDOadCk/LgIgAAADACAAAAMA0eMGVAEABGjuPIAAAAAYc3R0cwAAAAAAAAABAAAADgAAA+gAAAAUc3RzcwAAAAAAAAABAAAAAQAAABxzdHNjAAAAAAAAAAEAAAABAAAADgAAAAEAAABMc3RzegAAAAAAAAAAAAAADgAAAE8AAAAOAAAADQAAAA0AAAANAAAADQAAAA0AAAANAAAADQAAAA0AAAANAAAADQAAAA4AAAAOAAAAFHN0Y28AAAAAAAAAAQAAA7AAAAA0dXVpZFVTTVQh0k/Ou4hpXPrJx0AAAAAcTVREVAABABIAAAAKVcQAAAAAAAEAAAAAAAAAqHV1aWRVU01UIdJPzruIaVz6ycdAAAAAkE1URFQABAAMAAAAC1XEAAACHAAeAAAABBXHAAEAQQBWAFMAIABNAGUAZABpAGEAAAAqAAAAASoOAAEAZABlAHQAZQBjAHQAXwBhAHUAdABvAHAAbABhAHkAAAAyAAAAA1XEAAEAMgAwADAANQBtAGUALwAwADcALwAwADYAMAA2ACAAMwA6ADUAOgAwAAABA21kYXQAAAAYZ01AM5p0KT8uAiAAAAMAIAAAAwDR4wZUAAAABGjuPIAAAAAnZYiAIAAR//eBLT+oL1eA2Nlb/edvwWZflzEVLlhlXtJvSAEGRA3ZAAAACkGaAQCyJ/8AFBAAAAAJQZoCATP/AOmBAAAACUGaAwGz/wDpgAAAAAlBmgQCM/8A6YEAAAAJQZoFArP/AOmBAAAACUGaBgMz/wDpgQAAAAlBmgcDs/8A6YEAAAAJQZoIBDP/AOmAAAAACUGaCQSz/wDpgAAAAAlBmgoFM/8A6YEAAAAJQZoLBbP/AOmAAAAACkGaDAYyJ/8AFBAAAAAKQZoNBrIv/4cMeQ==";
			var $v = $(
				'<video playsinline muted><source src="' +
					mp4 +
					'" type="video/mp4"></video>',
			)[0];
			$("body").append($v);
			$v.play()
				.then((e) => {})
				.catch((e) => {
					console.warn("Your browser doesn't support autoplay", e);
					videoAllowed = false;
				})
				.then((e) => {
					$v.remove();
					create();
				});
		} else {
			// ie11
			create();
		}

		setTimeout(() => {
			const bg =
				document.querySelector(
					"header.PageHeader.PageHeader--withBackground > .Custom_PageHeader__ImageWrapper",
				)?.style?.backgroundImage || null;

			//console.log("Has bg", bg);

			// if (!bg) {
			// 	// FIX HEADER IMAGE DISPLAY BUG
			// 	const bgset = document
			// 		.querySelector(
			// 			"header.PageHeader.PageHeader--withBackground > .Custom_PageHeader__ImageWrapper",
			// 		)
			// 		.getAttribute("data-bgset");

			// 	const regex = /(\/\/[^\s]+)/g;
			// 	const matches = bgset.match(regex);

			// 	const windowWidth = window.innerWidth;

			// 	const imageWidths = [];
			// 	for (const url of matches) {
			// 		const regex = /(\d+)x/;
			// 		const match = url.match(regex);
			// 		if (match) {
			// 			imageWidths.push(parseInt(match[1]));
			// 		}
			// 	}

			// 	let closestWidth = Number.MAX_VALUE;
			// 	let closestUrl = null;
			// 	for (let i = 0; i < imageWidths.length; i++) {
			// 		const width = imageWidths[i];
			// 		const url = matches[i];
			// 		const diff = Math.abs(windowWidth - width);
			// 		if (diff < closestWidth) {
			// 			closestWidth = diff;
			// 			closestUrl = url;
			// 		}
			// 	}

			// 	document.querySelector(
			// 		"header.PageHeader.PageHeader--withBackground > .Custom_PageHeader__ImageWrapper",
			// 	).style.backgroundImage = `url(${closestUrl})`;
			// }
		}, 1000);
	}

	function create() {
		if (window.listItemExtras && window.listItemExtras.length) {
			window.shuffleArray(window.listItemExtras);
		} else {
			window.listItemExtras = [];
		}

		if (videoAllowed) {
			if (window.listItemExtrasVideos && window.listItemExtrasVideos.length) {
				window.shuffleArray(window.listItemExtrasVideos);
			} else {
				window.listItemExtrasVideos = [];
			}
		} else {
			window.listItemExtrasVideos = [];
		}

		allItemsExtra = allItemsExtra
			.concat(window.listItemExtrasVideos)
			.concat(window.listItemExtras);

		updateCollectionGrid();

		var debounceTimeout = 0;
		$(window).on("resize", function () {
			window.clearTimeout(debounceTimeout);
			debounceTimeout = setTimeout(_collectionPageThrottledResize, 300);
		});

		initialized = true;
	}

	function getProductItemExtraTemplate() {
		if (ProductItemExtraIndex >= allItemsExtra.length) {
			ProductItemExtraIndex = 0;
		}

		var ProductItemExtraTemplate = "";

		ProductItemExtraTemplate +=
			'<div class="ProductItemExtra__Cell Grid__Cell 2/3--tablet-and-up 1/2--lap-and-up">';
		ProductItemExtraTemplate +=
			'<div class="ProductItemExtra AspectRatio AspectRatio--natural-horizontal-photo">';
		if (allItemsExtra[ProductItemExtraIndex].match(".mp4")) {
			var clean_url = allItemsExtra[ProductItemExtraIndex].split(".mp4");
			clean_url = clean_url[0] + ".mp4";
			ProductItemExtraTemplate +=
				'<video muted playsinline loop class="ProductItem__Video Image--lazyLoad Image--fadeIn">';
			//ProductItemExtraTemplate += '<source src="' + allItemsExtra[ProductItemExtraIndex] + '" type="video/mp4">';
			ProductItemExtraTemplate +=
				'<source src="' + clean_url + '" type="video/mp4">';
			ProductItemExtraTemplate += "</video>";
		} else {
			ProductItemExtraTemplate +=
				'<img class="ProductItem__Image Image--lazyLoad Image--fadeIn" data-src="' +
				allItemsExtra[ProductItemExtraIndex] +
				'" data-sizes="auto" data-widths="[200,400,600,700,800,900,1000,1200]" alt="">';
			ProductItemExtraTemplate += "</div>";
			ProductItemExtraTemplate += "</div>";
		}

		ProductItemExtraIndex++;

		return ProductItemExtraTemplate;
	}

	function _collectionPageThrottledResize() {
		if (window.matchMedia("(min-width: 1008px)").matches) {
			if (window.nCols == 4) {
				return;
			}
		} else if (
			window.matchMedia("(min-width: 641px) and (max-width: 1007px)").matches
		) {
			if (window.nCols == 3) {
				return;
			}
		} else if (window.matchMedia("(max-width: 640px)").matches) {
			if (window.nCols == 2) {
				return;
			}
		}

		$(".ProductItemExtra__Cell").each(function (i, el) {
			$(el).remove();
		});

		updateCollectionGrid();
	}

	function _resetObserversArray() {
		var i;

		if (window.observers) {
			for (i = 0; i < window.observers.length; i++) {
				window.observers[i].observer.unobserve(window.observers[i].target);
			}
		}

		window.observers = [];

		if (window.videoObservers) {
			for (i = 0; i < window.videoObservers.length; i++) {
				window.videoObservers[i].observer.unobserve(
					window.videoObservers[i].target,
				);
			}
		}

		window.videoObservers = [];
	}

	function updateCollectionGrid() {
		// Setup parallax on image (if any)
		var collectionImageElement = $(".Custom_PageHeader__ImageWrapper")[0];

		// console.log('***** updateCollectionGrid *****');

		if (headerRellax) {
			headerRellax.destroy();
		}

		if (
			collectionImageElement &&
			window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches
		) {
			headerRellax = new Rellax(".Custom_PageHeader__ImageWrapper", {
				speed: -7,
				center: false,
				round: true,
			});
		}

		$(
			"#bc-sf-filter-options-wrapper .bc-sf-filter-option-swatch li a:not(.patch-luminance)",
		).each(function (i, el) {
			var BGcolor = $(el)
				.find(".bc-sf-filter-option-swatch-image")
				.css("background-color");
			if (chroma(BGcolor).luminance() >= 0.9) {
				$(el).addClass("patch-luminance");
			}
		});

		//buildSourcesArray();

		var $thumbs = $("#bc-sf-filter-products").find(
			".Grid__Cell:not(.ProductItemExtra__Cell)",
		);
		var pos;

		if (window.matchMedia("(min-width: 1008px)").matches) {
			pos = [0, 8, 12, 20];
			window.nCols = 4;
		} else if (window.matchMedia("(min-width: 641px)").matches) {
			pos = [6, 14];
			window.nCols = 3;
		} else {
			pos = [4, 10, 14];
			window.nCols = 2;
		}

		_resetObserversArray();

		if (!allItemsExtra.length) {
			return;
		}

		for (var i = 0; i < pos.length; i++) {
			if (pos[i] > $thumbs.length) {
				return;
			}

			var $extraEl = $(getProductItemExtraTemplate());

			if (pos[i] > $thumbs.length - 1) {
				$extraEl.insertAfter($thumbs[$thumbs.length - 1]);
			} else {
				$extraEl.insertBefore($thumbs[pos[i]]);
			}

			if (window.IntersectionObserver != undefined) {
				// in-viewport observer
				var observer = new window.IntersectionObserver(
					function (entries, observer) {
						var entry = entries[0];
						if (entry.isIntersecting) {
							/*console.log('this is', this, observer)*/
							observer.unobserve(entry.target);
							$(entry.target).addClass("in-viewport");
						}
					},
					{
						root: null,
						rootMargin: "0px 0px 0px 0px",
						threshold: 0,
					},
				);
				observer.observe($extraEl[0]);
				window.observers.push({
					observer: observer,
					target: $extraEl[0],
				});

				// video play observer
				if ($extraEl.find("video").length) {
					var videoObserver = new window.IntersectionObserver(
						function (entries, observer) {
							var entry = entries[0];
							if (entry.isIntersecting) {
								if (entry.target.paused) {
									entry.target.play().catch((e) => {
										console.log(e.name);
									});
								}
							} else {
								if (!entry.target.paused) {
									entry.target.pause();
								}
							}
						},
						{
							root: null,
							rootMargin: "0px 0px 0px 0px",
							threshold: 0,
						},
					);
					videoObserver.observe($extraEl.find("video")[0]);
					window.videoObservers.push({
						observer: videoObserver,
						target: $extraEl.find("video")[0],
					});
				}
			} else {
				$extraEl
					.find("video")
					.play()
					.catch((e) => {
						console.log(e.name);
					});
			}
		}
	}

	// Build additional elements
	// window.BCSfFilter.prototype.buildAdditionalElements = function (
	// 	data,
	// 	eventType,
	// ) {
	// 	if (!initialized) {
	// 		return;
	// 	}

	// 	updateCollectionGrid();

	// 	var filter_params = this.getFilterParams();
	// 	var selected_color =
	// 		filter_params &&
	// 		filter_params.pf_opt_color &&
	// 		filter_params.pf_opt_color.length > 0
	// 			? filter_params.pf_opt_color
	// 			: [];

	// 	var selected_color_code;

	// 	if (selected_color.length) {
	// 		selected_color = selected_color[0];
	// 		selected_color_code = $(
	// 			'.bc-sf-filter-option-block[data-type="opt_color"] ul.bc-sf-filter-option-swatch li a[data-value="' +
	// 				selected_color +
	// 				'"] .bc-sf-filter-option-swatch-image',
	// 		).css("background-color");
	// 	}

	// 	if (!selected_color_code) {
	// 		selected_color_code = "#EEEEEE";
	// 	}

	// 	window.updatePageBG(selected_color_code);
	// };
})(window);
